/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

module.exports = function (config, get, post) {

	return {
		list: list,
		add: add,
		remove: remove,
		reset: reset,
	};

	/**
	 * Gets a list of the tasks in the schedule of the user(staff) making the request.
	 * @return {Array}  Resolves to a list of the scheduling tasks of the user.
	 */
	function list() {
 		return get("/v2/schedule/list", {});
 	}

	/**
	 * Adds a task to a user(staff) schedule consisting of an object {action, time}
	 * @param {Object} action   {action, time} action=on/off, time=<<cron syntax>>
	 * @param {[type]} schedule [description]
	 */
	function add(data) {
		var action = data.action;
		var schedule = data.schedule;
		var timezone = data.timezone;
		return post("/v2/schedule/add", {
			action: action,
			schedule: schedule,
			timezone: timezone
		});
	}

	/**
	 * Removes a task from a user(staff) schedule consisting of an object {action, time}
	 * @param {Object} action   {action, time} action=on/off, time=<<cron syntax>>
	 * @param {[type]} schedule [description]
	 */
	function remove(data) {
		var action = data.action;
		var schedule = data.schedule;
		return post("/v2/schedule/remove", {
			action: action,
			schedule: schedule
		});
	}

	/**
	 * Removes _all_ the tasks a user has scheduled ie in the dB the user(staff)
	 * property 'schedule' becomes an empty array.
	 */
	function reset() {
		return post("/v2/schedule/reset", {});
	}

};
